import { render, staticRenderFns } from "./PersonAiCompanyAnalysisComments.vue?vue&type=template&id=268fb39e&"
import script from "./PersonAiCompanyAnalysisComments.vue?vue&type=script&lang=js&"
export * from "./PersonAiCompanyAnalysisComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports